import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSubmit = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.75 8.313v2.374h3.563v3.563h2.374v-3.563h3.563V8.313h-3.563V4.75H8.313v3.563H4.75ZM9.5 19a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19Z" />
  </svg>
);
const Memo = memo(SvgSubmit);
export default Memo;
